import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	margin: 0 auto;
`;

export const SwitchRow = styled.div`
	display: flex;
	justify-content: end;
	margin-bottom: 24px;
	align-items: center;

	@media (max-width: 997px) {
		align-items: flex-start;
		flex-direction: column;
		gap: 21px;
	}
`;

export const SwitchContainer = styled.div`
	background-color: ${({ theme }) => theme.colors.transparent.light10};
	border-radius: 100px;
`;

export const SwitchButton = styled.button<{ $isActive: boolean }>`
	padding: 9px 8px;
	border-radius: 100px;

	font-size: 14px;
	line-height: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};

	cursor: pointer;

	${({ $isActive }) =>
		$isActive &&
		css`
			background-color: ${({ theme }) => theme.colors.control.darkToggle};
			color: ${({ theme }) => theme.colors.text.alwaysWhite};
		`}
`;

export const CurrentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const CurrentCards = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(1fr);
	grid-column-gap: 16px;
	grid-row-gap: 16px;

	margin-bottom: 64px;

	@media (max-width: 997px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;

export const CompletedCards = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-template-rows: repeat(1fr);
	grid-column-gap: 16px;
	grid-row-gap: 16px;

	margin-bottom: 64px;

	@media (max-width: 1440px) {
		grid-template-columns: repeat(3, 1fr);
	}

	@media (max-width: 997px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;
